import { BreadcrumbItemListCombinedProps } from './types';

const usePresenter = (props: BreadcrumbItemListCombinedProps): BreadcrumbItemListCombinedProps => {
  return props;
};

export default usePresenter;
